export const WRAPPER_MAIN_ELEMENT_SLOT_ID = 'main';
export const WRAPPER_HEADER_SLOT_ID = 'header';
